<video [src]="videoSrc" controls width="800" height="600"></video>
